//core
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";
import { Box, Tooltip } from "@mui/material";

//icons
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Contact from "../Contact";

const useStyles = makeStyles<Theme>((theme) => ({
  block: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 4,
    color: 'inherit',
  },
  text: {
    whiteSpace: 'nowrap',
    color: 'inherit',
    '& a': {
      color: 'var(--text-primary)',
      maxWidth: 140,
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis',
    },
    '& span': {
      maxWidth: 160,
      overflow: 'hidden',
      display: 'block',
      textOverflow: 'ellipsis',
    },
  },
  icon: {
    width: 16,
    height: 16,
    color: theme.palette.action.active,
    '& svg': {
      width: 16,
      height: 16,
    }
  },
  wrapper: {
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "100%",
  },
  messenger: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: "100%",
    gap: 4,
  },
}));

interface IMessengerItem {
  messenger: {
    type: string;
    value: string;
  },
  isPublic: boolean;
}

interface IContact {
  value: IMessengerItem[];
  className?: string;
}


const ArrayOfCashierMessengers: React.FC<IContact> = ({ value, className = '' }): JSX.Element => {
  const styles = useStyles();
  const { t } = useTranslation();
  const wrapperRef: any = useRef(null);

  const renderMessengerItem = (item: IMessengerItem, i: number, isTooltip = false) => {
    const messengerValue = JSON.parse(item.messenger.value);
    const value = item.messenger.type === 'other'
      ? `${messengerValue.name} - ${messengerValue.value}`
      : messengerValue.value;

    return (
      <Box key={`${item.messenger.type}-${i}`} className={styles.messenger} sx={isTooltip ? { color: 'white' } : {}}>
        <Box>
          <Contact type={item.messenger.type} value={`${value}`} hideOtherTooltip={true} isTooltipContent={isTooltip} />
        </Box>
        {!item.isPublic && (
          isTooltip ? (
            <VisibilityOffIcon color="primary" style={{ fontSize: '16px' }} />
          ) : (
            <Tooltip title={t("common.messages.notPublicContact")}>
              <VisibilityOffIcon color="primary" style={{ fontSize: '16px' }} />
            </Tooltip>
          )
        )}
      </Box>
    );
  };

  const tooltipContent = (
    <Box>
      {value.map((item, i) => renderMessengerItem(item, i, true))}
    </Box>
  );

  return (
    <>
      <Box ref={wrapperRef} className={styles.wrapper}>
        {value.length > 0 ? (
          <Tooltip placement="bottom-start" title={tooltipContent}>
            <Box>
              {value.slice(0, 3).map((item, i) => renderMessengerItem(item, i))}
            </Box>
          </Tooltip>
        ) : (
          <>{'—'}</>
        )}
      </Box>
    </>
  );
};

export default ArrayOfCashierMessengers;
